export function product(state) {
  return state.product;
}
